export const medicalMailProcessSelect = [
    {
        label: 'Effecteur + équipe de soin',
        value: 'Both',
    },
    {
        label: 'Uniquement effecteur',
        value: 'OnlyToCareGiver',
    },
    {
        label: 'Uniquement équipe de soin',
        value: 'OnlyToOrg',
    },
]
export const admMailProcessSelect = [
    {
        label: 'Effecteur + courriels administratifs',
        value: 'Both',
    },
    {
        label: 'Uniquement effecteur',
        value: 'OnlyToCareGiver',
    },
    {
        label: 'Uniquement courriels adminstratifs',
        value: 'OnlyToAdm',
    },
]
